import { SiteMessageSeverity } from '../components/header/SiteMessage';

export interface ISiteMessageState {
  active: boolean;
  message?: string;
  severity?: SiteMessageSeverity;
}
const initialState: ISiteMessageState = {
  active: false,
  message: null,
  severity: null
};

export default function (
  state: ISiteMessageState = initialState,
  action
): ISiteMessageState {
  switch (action.type) {
  }

  return state;
}
